__turbopack_context__.v({
  "cta": "TravelChargerSequence-module__RuRlLG__cta",
  "ctaContainer": "TravelChargerSequence-module__RuRlLG__ctaContainer",
  "learnMore": "TravelChargerSequence-module__RuRlLG__learnMore",
  "primary": "TravelChargerSequence-module__RuRlLG__primary",
  "root": "TravelChargerSequence-module__RuRlLG__root",
  "sectionContent": "TravelChargerSequence-module__RuRlLG__sectionContent",
  "subText": "TravelChargerSequence-module__RuRlLG__subText",
  "textContent": "TravelChargerSequence-module__RuRlLG__textContent",
});
